import Constants from 'constants.js';
import Dispatcher from 'core/Dispatcher';

class AlertAction {

    open(type, text, pos) {
        let position = pos;
        if (!position || typeof position === 'undefined') {
            position = 'top-end';
        }
        if (!text || typeof text === 'undefined' || !type || typeof type === 'undefined') {
            return false;
        }

        Dispatcher.dispatch({
            actionType: Constants.ALERT_OPEN,
            value: {
                text,
                type,
                position
            }
        });
    }

    close() {
        Dispatcher.dispatch({
            actionType: Constants.ALERT_CLOSE
        });
    }
}

export default new AlertAction();
